<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-terms"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <div id="terms_header" class="modal-head-txt theme-txt" v-html="title"></div>
                </div>
                <div class="modal-base-body" >
                    <PDPA :lblCode="lblCode"
                        :controller="controller"
                        :busPDPA="busPDPA"
                        ref="el"
                        @onScroll="onScroll($event)"></PDPA>
                    <!-- <div @click="ClickToBottom()">
                        Tab to Bottom
                    </div> -->
                </div>
                <div class="modal-base-footer">
                    <div id="close_terms_modal" v-if="tag != 'accept-terms'">
                        <div class="btn-wrapper btn-cancel" @click="hide()">
                            <div class="btn-txt">
                                {{lbl.register.btn_close}}
                            </div>
                        </div>
                    </div>
                    <div id="accept_terms_modal">
                        <div class="btn-wrapper"
                             @click="clickAcceptTerms()" v-if="bottomOfContent || isAcceptTerms">
                            <div class="btn-txt">
                                {{btnAcceptTerms}}
                            </div>
                        </div>
                        <div class="btn-wrapper btn-disable" v-else>
                            <div class="btn-txt">
                                {{btnAcceptTerms}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
//hepler
import Locale from '@/helper/locale/locale.js';
import Util from "@/helper/Utility.js";
//component
// import Pdpa from "@/components/PDPA/Page/PDPA.vue";
import PDPA from "../../PDPA/Page/PDPA.vue";
// import { useInfiniteScroll } from '@vueuse/core'
export default {
    name: "termsModal",
    components: {
        PDPA
    },
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function () {
        return {
            title: '',
            tag: '',
            btnAcceptTerms: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            busPDPA: new Vue(),
            bottomOfContent: false,
            isAcceptTerms: false
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        clickAcceptTerms: function () {
            if(this.bottomOfContent){
                this.hide();
                this.controller.sendCallbackAcceptTerms({ tag: this.tag }, true);
            }
        },
        //control
        show: function(config) {
            this.title = config.title;
            this.btnAcceptTerms = config.btnAcceptTerms;
            this.tag = config.tag;
            this.bottomOfContent = false;
            this.isAcceptTerms = config.isAcceptTerms;
            if (Util.isEmptyStr(config.btnAcceptTerms)) {
                this.btnAcceptTerms = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        onScroll (scrollBottom) {
            if (scrollBottom) {
                this.bottomOfContent = true;
            } else {
                this.bottomOfContent = false;
            }
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
    .modal-base-footer {
        @extend %display-flex;
        width: 100%;
        // flex : 0 0 calc(100% / 2);
        align-items: center;
        gap: 10px;
        #close_terms_modal {
            width: 35%;
        }
        #accept_terms_modal {
            width: 60%
        }
    }
</style>
<style lang="scss">
@import "@/style/modal.scss";
    .modal-terms {
        @extend %modal-base;

        .modal-dialog {
            height: 90vh;
            max-height: 90vh;
        }
    }
</style>
